module.exports = __webpack_public_path__ + "img/power-swiper-item (5).a41eba05.png";